import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';

export const baseURI = '/configuracion/licencias-de-funcionamiento/';
const files = ['archivos_adjuntos'];
/**
 * GET LicenciasDeFuncionamiento
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getLicenciasDeFuncionamiento = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data.results;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET LicenciaDeFuncionamiento
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getLicenciaDeFuncionamiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST LicenciaDeFuncionamiento
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLicenciaDeFuncionamiento = async (values) => {
  try {
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: false,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH LicenciaDeFuncionamiento
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchLicenciaDeFuncionamiento = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(_values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE LicenciaDeFuncionamiento
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteLicenciaDeFuncionamiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
